import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Header() {
  const [open, setOpen] = useState(false);

  const menuItems = [
    { name: "ORIGIN", link: "#origin" },
    { name: "PETTYNOMICS", link: "#pettynomics" },
    { name: "ROADMAP", link: "#roadmap" },
    { name: "APP", link: "#fmexapp", comingSoon: true },
    { name: "UTILITY", link: "#token-utility" },
    { name: "FAQ", link: "#FAQ" },
  ];

  const [small, setSmall] = useState(() => {
  if (typeof window !== "undefined") {
    return window.scrollY > 40; // initial shrink state
  }
  return false;
});

useEffect(() => {
  const handleScroll = () => {
    setSmall(window.scrollY > 40); // shrink threshold
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

  // 🔥 Smooth scroll handler (used for desktop + mobile)
  const smoothScroll = (e, link) => {
  e.preventDefault();

  const target = document.querySelector(link);
  if (!target) return;

  const offset = 110;
  const top =
    target.getBoundingClientRect().top + window.scrollY - offset;

  setOpen(false);

  // Mobile is slower — bigger delay required
  const delay = window.innerWidth < 768 ? 350 : 250;

  setTimeout(() => {
    window.scrollTo({
      top,
      behavior: "smooth",
    });
  }, delay);
};

  return (
    <>
      

      <header className="fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[95%]">
        <motion.div
  initial={false}   // ← prevents initial mount animation
  animate={small ? "small" : "big"}
  variants={{
    big: {
      scale: 1,
      y: 0,
      borderRadius: "1.2rem",
      paddingTop: "1rem",
      paddingBottom: "1rem",
    },
    small: {
      scale: 0.92,
      y: -10,
      borderRadius: "1rem",
      paddingTop: "0.5rem",
      paddingBottom: "0.5rem",
      transition: { type: "spring", stiffness: 300, damping: 20 },
    },
  }}
  className="bg-white/30 backdrop-blur-2xl border border-black/20 rounded-2xl px-6 py-4 shadow-xl comic-shadow"
>

          <nav className="flex items-center justify-between">

            {/* LOGO */}
            <div className="flex items-center gap-4">
              <img
                src="/images/fmexlogo.png"
                alt="FMEX Logo"
                className="w-10 h-10 drop-shadow-md"
              />
              <h1 className="text-2xl font-semibold font-darumadrop tracking-wider drop-shadow-md">
                FMEX
              </h1>
            </div>

            {/* DESKTOP MENU */}            
<div className="hidden lg:flex items-center gap-8 text-lg font-bold font-darumadrop">
  {menuItems.map((item, index) => (
    <div key={index} className="relative flex items-center gap-2">
      <motion.a
        href={item.link}
        className="relative inline-block font-bold cursor-pointer"
        whileHover="hover"
        initial="rest"
        onClick={(e) => smoothScroll(e, item.link)}
      >
        {item.name}

        {/* WAVY UNDERLINE */}
        <motion.span
          className="absolute left-0 -bottom-1 h-[4px] w-full origin-left"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='40' height='6'><path d='M0 3 Q5 0 10 3 T20 3 T30 3 T40 3' stroke='hotpink' stroke-width='6' fill='none' stroke-linecap='round' stroke-dasharray='8 4'/></svg>\")",
            backgroundRepeat: "repeat-x",
            backgroundSize: "40px 6px",
          }}
          variants={{
            rest: { scaleX: 0, opacity: 0 },
            hover: {
              scaleX: 1,
              opacity: 1,
              transition: { type: "spring", stiffness: 450, damping: 20 },
            },
          }}
        />
      </motion.a>

      {/* COMING SOON BADGE */}
      {item.comingSoon && (
        <span className="text-[9px] px-2 py-[1px] bg-yellow-300 border border-black rounded font-bold uppercase comic-shadow">
          Coming Soon
        </span>
      )}
    </div>
  ))}

  {/* CUSTOM IMAGE BUTTON */}
  <button onClick={(e) => smoothScroll(e, "#presale")}>
  <motion.img
    src="/images/buyfmex.png"
    alt="custom button"
    className="h-10 w-auto cursor-pointer select-none"
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.95 }}
  />
</button>
</div>
          

            {/* MOBILE BURGER */}
            <button
              className="lg:hidden flex flex-col gap-1"
              onClick={() => setOpen(!open)}
            >
              <div className="w-6 h-[3px] bg-black rounded"></div>
              <div className="w-6 h-[3px] bg-black rounded"></div>
              <div className="w-6 h-[3px] bg-black rounded"></div>
            </button>
          </nav>

          {/* MOBILE DROPDOWN */}
<AnimatePresence>
  {open && (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: "auto" }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.25 }}
      className="lg:hidden mt-4 flex flex-col gap-4 font-bold"
    >
      {menuItems.map((item, index) => (
        <div key={index} className="relative flex items-center gap-2">
          <button
            className="py-2 border-comic bg-white rounded-lg px-3 text-left w-full"
            onClick={(e) => smoothScroll(e, item.link)}
          >
            {item.name}
          </button>

          {item.comingSoon && (
            <span className="text-[9px] px-2 py-[1px] bg-yellow-300 border border-black rounded font-bold uppercase comic-shadow">
              Coming Soon
            </span>
          )}
        </div>
      ))}

      {/* CUSTOM BUTTON MOBILE */}
<button
  onClick={(e) => smoothScroll(e, "#presale")}
  className="mx-auto"
>
  <img 
    src="/images/buyfmex.png"
    alt="custom button mobile"
    className="h-12 w-auto cursor-pointer"
  />
</button>
    </motion.div>
  )}
</AnimatePresence>

        </motion.div>
      </header>
    </>
  );
}
